export const resetComments = resp => ({
  type: "RESET_COMMENTS"
});

export const fetchComments = resp => ({
  type: "FETCH_COMMENTS",
  payload: resp
});

export const saveComment = resp => ({
  type: "SAVE_COMMENT",
  payload: resp
});

export const fetchInfiniteComments = resp => ({
  type: "FETCH_INFINITE_COMMENTS",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/comment.js